import { getCachedData } from "api/Cache";
import { useCallback, useEffect, PropsWithChildren, useState } from "react";
import { CircularProgress } from "@mui/material";
import { CircularProgressWithLabel } from "components";
import EventsEmitter from "events/EventsEmitter";


interface LoaderComponentProps extends PropsWithChildren<{}> {
    onDataLoad?: (data: any) => void;
};

const CacheDataLoader: React.FC<LoaderComponentProps> = ({ onDataLoad, children }) => {
    const cachedData = getCachedData();
    const [loadData, setLoadData] = useState(false);
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const handleProgress = (curProgress: number) => {
            setProgress(curProgress);
        };

        if (cachedData.loaded && !loadData) {
            setLoadData(true);
            onDataLoad && onDataLoad(cachedData);
        }

        EventsEmitter.on("projects_progress", handleProgress);
        return () => {
            EventsEmitter.removeEventListener("projects_progress", handleProgress);
        };
    }, [cachedData, loadData, progress, setLoadData]);

    if (!loadData) {
        return progress === 0 ? <CircularProgress /> : <CircularProgressWithLabel value={progress} />;
    }

    return (
        <div>
            {children}
        </div>
    );
}

export default CacheDataLoader;
